/**
 * sessionStorage key for the return URL, namespaced to avoid collisions.
 * @type {string}
 */
export const RETURN_URL_KEY = "ciq:returnUrl"

/**
 * Saves the current URL (pathname + search + hash) to sessionStorage
 * before a Cognito login redirect. Skips saving if the URL is just
 * the root path with no query params or hash (nothing to return to).
 */
export const saveReturnUrl = () => {
  const url =
    window.location.pathname + window.location.search + window.location.hash
  if (url && url !== "/") {
    sessionStorage.setItem(RETURN_URL_KEY, url)
  }
}

/**
 * Reads and removes the saved return URL from sessionStorage.
 * Returns null if no URL was saved or if the URL fails same-origin
 * validation (must start with "/" and not "//").
 *
 * @returns {string|null} The saved return URL, or null if none exists or validation fails
 */
export const consumeReturnUrl = () => {
  const url = sessionStorage.getItem(RETURN_URL_KEY)
  sessionStorage.removeItem(RETURN_URL_KEY)
  if (url && url.startsWith("/") && !url.startsWith("//")) {
    return url
  }
  return null
}
